import { Config, Driver, driver, Side, Alignment } from 'driver.js';

export const createNewMenuItemDriver = (afterClosed: () => void): Driver => {
  const allSteps = [
    {
      element: '[data-guide=tracker-menu]',
      popover: {
        title: 'Progress Tracker',
        description:
          'Track and update information and delivery status for all project files, assign files, and set completion dates.',
        align: 'start' as Alignment,
        side: 'right' as Side
      }
    }
  ];

  const availableSteps = allSteps.filter((step) => {
    const element = document.querySelector(step.element);
    return element !== null;
  });

  const options: Config = {
    showProgress: true,
    disableActiveInteraction: true,
    allowClose: false,
    popoverClass: 'driver-guide',
    progressText: '{{current}} out of {{total}}',
    prevBtnText: 'Previous',
    nextBtnText: 'Next',
    steps: availableSteps
  };

  const guide = driver(options);
  if (!afterClosed) return guide;
  options.steps[options.steps.length - 1].popover.onNextClick = () => {
    afterClosed();
    guide.moveNext();
  };
  return guide;
};
